<template>
    <div class="store position-relative">
        <div class="store-container border-radius-main p-2 mt-2 mb-2">

            <div class="d-flex mb-1 mt-3 align-items-center store-title-container">
                <h5 class="store-content store-title font-regular  h4">{{ store.title }}</h5>
                <p class="ps-2 distance d-inline-block small" v-if="store.distance.text!==''">({{ store.distance.text }})</p>
            </div>

            <a :href="`tel:${phoneNumberFormatter}`" class="store-content store-phone font-regular mb-1 bg-secondary-l d-inline-flex align-items-center p-1 border-radius-main">
                <div class="icon-wrapper border-radius-main no-overflow me-1">
                    <svg class="icon-base"><use xlink:href="/dist/icons/solid.svg#phone"></use></svg>
                </div>
                {{ store.phone }}
            </a>

            <div class="store-content store-address font-regular">{{ store.address }}</div>

            <div class="store-content store-locality font-regular line-1 mb-1">{{ store.zip }} {{ store.city }}</div>

            <div class="text-long mb-1">
                <a :href="store.path" v-on:click.prevent.stop="gtmGoingToStore" class="store-btn zur-btn-map me-1 mb-1 d-inline-block position-relative"><font-awesome-icon class="mr-1" icon="map-marker-alt"/>
                    {{ text.to_the_store }}
                </a>
            </div>

            <div class="field-store-status font-regular" v-html="status"></div>


            <div class="position-relative d-flex flex-wrap pt-2 font-regular">
                <a href="#" class="store-btn termin-btn mt-1 d-inline-block position-relative btn btn-primary mob-small icon-left w-100" v-on:click.prevent.stop="proceedEtermin" v-if="store.calenderid">
                        <span class="d-flex align-items-center justify-content-center">
                            <div class="icon-wrapper border-radius-main no-overflow ">
                                <svg class="icon-base"><use xlink:href="/dist/icons/solid.svg#calendar"></use></svg>
                            </div>
                            <span>{{ text.book }}</span>
                        </span>
                </a>
            </div>

        </div>
    </div>
</template>

<script>
import { buildStatus } from '@/services/StoreStatus.js'
import ServiceDrupal from '@/services/ServiceDrupal.js'
import {mapState} from "vuex";

export default {
    name: 'storeMap',
    props: {
        store: {
            type: Object,
            required: true
        },
        onMap: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data () {
        return {
            status: `<div class='loading-status mb-1'></div>`,
            StatusCreated: 0,
            text: {
                to_the_store: Drupal.t('To the store'),
                book: Drupal.t('Book an appointment'),
                minimal_to_the_store: Drupal.t('Store'),
                minimal_book: Drupal.t('Appointment')
            }
        }
    },
    computed: {
        phoneNumberFormatter () {
            return this.store.phone.replace(/[ ()]/g, '')
        }
    },
    methods: {
        proceedEtermin () {
            this.$store.dispatch('setStore', {
                source: 'left',
                store: this.store
            })
            this.$store.dispatch('notification/clear', null)
            this.$store.dispatch('activateProceed', null)
            this.gtmBookingAppointment()
        },

        async requestStatus () {
            let data = {
                opening_hours: this.store.openinghours,
                lunch_break: JSON.parse(this.store.lunchbreak),
                federal_state: this.store.federalstate,
                special_hours: JSON.parse(this.store.specialbushours)
            }
            this.status = await buildStatus(data, 'm')
        },

        gtmGoingToStore () {
            // Google Tag-Manager push 'click on button `Zur Filiale`' to dataLayer
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: `store_search`,
                    event_type: this.onMap ? `click_map_to_store` : `click_list_to_store`,
                    event_data: {
                        store_name: this.store.title
                    }
                })
            }
            location.href =  this.store.path
        },

        gtmBookingAppointment () {
            // Google Tag-Manager push 'click on button `Termin buchen`' to dataLayer
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: `store_search`,
                    event_type: this.onMap ? `click_map_booking` : `click_list_booking`,
                    event_data: {
                        store_name: this.store.title
                    }
                })
            }
        }
    },
    updated () {
        if (this.StatusCreated !== 1) {
            this.requestStatus()
        }
    },
    mounted () {
        this.StatusCreated = 1
        this.requestStatus()
        setTimeout(() => {
            this.StatusCreated = 0
        }, 50)
    }
}
</script>
